import { Package, Truck, Award } from "lucide-react";
import { useTranslation } from "react-i18next";

const StatsSection = () => {
  const { t } = useTranslation();

  const stats = [
    { icon: Package, value: "5 000+", label: t("stats.orders") },
    { icon: Truck, value: t("stats.shippingValue"), label: t("stats.shipping") },
    { icon: Award, value: "15 lat", label: t("stats.warranty") },
  ];

  return (
    <section className="py-10 md:py-16 gradient-navy">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-3 gap-4 md:gap-8">
          {stats.map((s, i) => (
            <div key={i} className="text-center">
              <s.icon className="w-7 h-7 md:w-10 md:h-10 text-accent mx-auto mb-2 md:mb-3" />
              <p className="text-xl md:text-3xl lg:text-4xl font-bold text-primary-foreground mb-0.5 md:mb-1">{s.value}</p>
              <p className="text-primary-foreground/70 text-xs md:text-base">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
